/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";

const $nsid = "place.stream.game.getGame";

export { $nsid };

export const $params = /*#__PURE__*/ l.params({"uri":/*#__PURE__*/ l.string({"format":"at-uri"})});

export type $Params = l.InferOutput<typeof $params>;

export const $output = /*#__PURE__*/ l.jsonPayload({"uri":/*#__PURE__*/ l.string({"format":"at-uri"}),"name":/*#__PURE__*/ l.string(),"summary":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),"coverUrl":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),"genres":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.array(/*#__PURE__*/ l.string(), ))});

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>;
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $output, B>;

const main = /*#__PURE__*/ l.query($nsid, $params, $output);

export { main };

export const $lxm = $nsid;
